import Views from '../../produto/spa/administracao/Views';

export default Views;
